<template>
	<div class="product-stock" style="overflow-x: auto">

		<template v-if="productstock.length > 0" >
			<table class="table table-bordered">
				<thead>
					<tr>
						<td>Option</td>
						<td>Quantity</td>
						<td>Price</td>
						<td>Sale Price</td>
						<td></td>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(productstock,index) in productstock" :key="'stock_'+ index">
						<td>
							<input type="text" :name="'option[]'" :data-vv-name="'option[]'" data-vv-as="Option" v-validate="'required'" class="form-control" id="optionInput" placeholder="" v-model="productstock[1]" >
						</td>
						<td style="max-width: 50px">
							<input type="text" :name="'quantity[]'" :data-vv-name="'quantity[]'" data-vv-as="Quantity" v-validate="'required|numeric'" maxlength="3" pattern="[0-9]*" inputmode="numeric" class="form-control" id="quantityInput" placeholder="" v-model="productstock[2]" >
						</td>
						<td><input type="text" :name="'price[]'" :data-vv-name="'price[]'" data-vv-as="Price" v-validate="'decimal:2|min_value:1'" pattern="[0-9]*" inputmode="numeric" class="form-control" id="priceInput" placeholder="(Optional)" v-model="productstock[3]" ></td>
						<td><input type="text" :name="'saleprice[]'" :data-vv-name="'saleprice[]'" data-vv-as="Sale Price" v-validate="'decimal:2|min_value:1|isLessThanOrEqual:'+ productstock[3]" pattern="[0-9]*" inputmode="numeric" class="form-control" id="priceInput" placeholder="(Optional)" v-model="productstock[4]" ></td>
						<td>
							<a href="javascript:void(0);" @click="deleteProductStock(index,productstock[0])"><i class="fa fa-trash middle"></i></a>
						</td>
					</tr>
				</tbody>
			</table>
		</template>

		<a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" @click="addProductStock"><span class="glyphicon glyphicon-plus"></span> Add Stock</a>

		

	</div>
</template>

<script>
import api from '@/api'
import AddStock from './AddStock'

export default{
	props:['value'],
	inject: ['$validator'],
	data: function(){
		return {
			productstock: this.value,
			newProductStock: {
				option: null,
				quantity: 0
			},
			min: 0,
			max: 999,
			isAdd: false,
			deletelist: []
		}
	},
	mounted: function(){	
		if (this.productstock.length == 0) {
			this.addProductStock()
		}
	},
	components: {
		AddStock,
	},
	methods: {
		addProductStock: function(){
			let vm = this
			vm.productstock.push([
				null,
				null,
				null,
				null,
				null
			])

		},
		deleteProductStock: function(index, id){
			let vm = this
			
			if (vm.productstock.length <= 1) {
				alert("The stock must have at least 1")
				return false;
			}
			if (confirm('Do you want to delete this?')) {
				if (id != null) {
					vm.deletelist.push(id)
					vm.$emit('deleteStock', id)
				} 
				vm.productstock.splice(index,1)
			}
		},
	},
	watch: {
		'value': function(newVal , oldVal){
			this.productstock = this.value
		},
		'productstock': function(){
			this.$emit('input',this.productstock)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductStock.vue